import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const PaymentSuccessHandler = ({ children }) => {
  const location = useLocation();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    const urlParams = new URLSearchParams(location.search);
    const paymentStatus = urlParams.get('status');
    const transactionId = urlParams.get('transaction_id');
    const cancelReason = urlParams.get('cancel_reason');
    const paymentSuccess = urlParams.get('payment_success');
    
    if (paymentSuccess === '1' || paymentStatus === 'success' || transactionId) {
      handledRef.current = true;
      setIsSuccess(true);
      setShowSuccessMessage(true);
      
      const newUrl = location.pathname;
      window.history.replaceState({}, document.title, newUrl);
      
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 5000);
    } else if (cancelReason || paymentStatus === 'cancelled') {
      handledRef.current = true;
      setIsSuccess(false);
      setShowSuccessMessage(true);
      
      const newUrl = location.pathname;
      window.history.replaceState({}, document.title, newUrl);
      
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 5000);
    }
  }, [location]);

  return (
    <>
      {showSuccessMessage && (
        <div style={{
          position: 'fixed',
          top: '100px',
          right: '20px',
          backgroundColor: isSuccess ? '#4CAF50' : '#f44336',
          color: 'white',
          padding: '15px 20px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          zIndex: 1000,
          maxWidth: '340px',
          animation: 'paymentToastSlideIn 0.3s ease-out'
        }}>
          <div style={{ fontWeight: 'bold', marginBottom: '5px', fontSize: '15px' }}>
            {isSuccess ? 'Payment Successful!' : 'Payment Cancelled'}
          </div>
          <div style={{ fontSize: '14px', opacity: 0.95 }}>
            {isSuccess 
              ? 'Your purchase is being processed. Products will appear below shortly.'
              : 'Your payment was cancelled. You can try again from the cart.'
            }
          </div>
          <style>
            {`
              @keyframes paymentToastSlideIn {
                from { transform: translateX(100%); opacity: 0; }
                to { transform: translateX(0); opacity: 1; }
              }
            `}
          </style>
        </div>
      )}
      {children}
    </>
  );
};

export default PaymentSuccessHandler;